import { type ReactElement } from 'react';
import { PsychoCardSkeleton } from '../../../../ui/PsychoCard/PsychoCardSkeleton';

const PSYCHOLOGIST_CARD_COUNT = 3;

export const PsychologistStepSkeleton = (): ReactElement => (
  <div className="flex flex-col gap-4">
    {Array.from({ length: PSYCHOLOGIST_CARD_COUNT }, (_, index) => (
      <PsychoCardSkeleton key={index} />
    ))}
  </div>
);
